import React, { Component } from 'react';
import { sanitizeHtml } from '../sanitize';

export class SideNav extends Component {
    static displayName = SideNav.name;

    constructor(props) {
        super(props);
        this.state = {
            componentId: props.componentId,
            sideNav: null
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    render() {
        let content;
        if (this.state.sideNav != null) {
            let sideNav = this.state.sideNav;
            content = sideNav.content;
        }

        return (
            <aside className='side-nav-container' aria-label="Side navigation">
                <div className='side-nav-content' dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}></div>
            </aside>  
        );
    }

    async getComponentData() {
        const response = await fetch('Components/GetSideNav?componentId=' + this.state.componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        if (data != null) {
            this.setState({
                sideNav: data
            });
        }
    }
}

export default SideNav;
